import React from 'react'
import { Link } from 'react-router'
import { formatDate, formatTime, getMeetupStatus } from '../utils/helpers'
import { CalendarIcon, MapPinIcon, UserGroupIcon, ClockIcon } from '@heroicons/react/24/outline'

export default function MeetupCard({ meetup, isPast = false }) {
  const status = getMeetupStatus(meetup.date, meetup.startTime)
  // null = geen maximum: dan nooit "Vol" of "Nog N plekken"
  const spotsLeft = meetup.registrationCounts?.available ?? null

  return (
    <div className={`card transition-shadow duration-200 ${isPast ? 'opacity-60 grayscale' : 'hover:shadow-lg'}`}>
      <div className="card-body">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center space-x-2 mb-2">
              {isPast ? (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400">
                  Afgelopen
                </span>
              ) : (
                <>
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    status.color === 'green' ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300' :
                    status.color === 'orange' ? 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300' :
                    'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300'
                  }`}>
                    {status.label}
                  </span>
                  {spotsLeft > 0 && spotsLeft <= 5 && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300">
                      Nog {spotsLeft} plekken
                    </span>
                  )}
                  {spotsLeft === 0 && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300">
                      Vol
                    </span>
                  )}
                </>
              )}
            </div>

            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              {meetup.title}
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-500 dark:text-gray-400">
              <div className="flex items-center space-x-2">
                <CalendarIcon className="h-4 w-4" />
                <span>{formatDate(meetup.date)}</span>
              </div>
              <div className="flex items-center space-x-2">
                <ClockIcon className="h-4 w-4" />
                <span>{formatTime(meetup.startTime)} - {formatTime(meetup.endTime)}</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPinIcon className="h-4 w-4" />
                <span>{meetup.location}</span>
              </div>
              <div className="flex items-center space-x-2">
                <UserGroupIcon className="h-4 w-4" />
                <span>
                  {meetup.registrationCounts?.confirmed ?? 0}
                  {meetup.maxParticipants != null && `/${meetup.maxParticipants}`} deelnemers
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-600">
          <Link
            to={`/meetup/${meetup.id}`}
            className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-500 text-sm font-medium transition-colors"
          >
            Meer details →
          </Link>
        </div>
      </div>
    </div>
  )
}
